import * as types from "./mutation-type";
import { getTaskCategoriesQuery } from "./queries.graphql";
import gqlClient from "@/modules/graphql";
import api from "@/modules/api";

const actions = {
  async getTaskCategories({ commit }, variables = {}) {
    try {
      commit(types.GET_TASKCATEGORIES_BEGIN);

      const {
        data: {
          data: {
            company: { taskCategories }
          }
        }
      } = await gqlClient.query({
        query     : getTaskCategoriesQuery,
        variables : variables
      });
      commit(types.GET_TASKCATEGORIES_SUCCESS, taskCategories);
    } catch (e) {
      commit(types.GET_TASKCATEGORIES_ERROR, e);
    }
  },
  async deleteTaskCategory({ commit }, id) {
    try {
      commit(types.DELETE_TASKCATEGORY_BEGIN);
      await api.taskCategory.deleteTaskCategory(id);
      commit(types.DELETE_TASKCATEGORY_SUCCESS, id);
    } catch (e) {
      commit(types.DELETE_TASKCATEGORY_ERROR, e);
    }
  },
  async createTaskCategory({ commit }, variables) {
    try {
      commit(types.CREATE_TASKCATEGORY_BEGIN);
      const { data }= await api.taskCategory.addTaskCategory(variables);
      commit(types.CREATE_TASKCATEGORY_SUCCESS, data);
    } catch (e) {
      commit(types.CREATE_TASKCATEGORY_ERROR, e);
    }
  },
  async updateTaskCategory({ commit }, { id,data }) {
    try {
      commit(types.UPDATE_TASKCATEGORY_BEGIN);
      const { data:updateData }= await api.taskCategory.updateTaskCategory(id,data);
      commit(types.UPDATE_TASKCATEGORY_SUCCESS, updateData);
    } catch (e) {
      commit(types.UPDATE_TASKCATEGORY_ERROR, e);
    }
  }
};

export default actions;